// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VueWow from "vue-wow";
import VueWechatTitle from "vue-wechat-title";
import VueI18n from "vue-i18n";
import axios from "axios";
import VideoPlayer from "vue-video-player";
import VueMeta from "vue-meta";
import { Alert, Confirm, Toast, Loading } from "wc-messagebox";
import { Pagination } from "element-ui";
import { isEmpty } from "lodash";
import "@/assets/css/reset.css";
import "@/assets/css/animate.css";
import "wc-messagebox/style.css";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(VueMeta);
Vue.use(VueI18n);
Vue.use(Alert);
Vue.use(Confirm);
Vue.use(Toast, 2000);
Vue.use(Loading);
Vue.use(VueWow);
Vue.use(Pagination);
Vue.use(VueWechatTitle);
Vue.use(VideoPlayer);
Vue.prototype.$axios = axios;
Vue.prototype.api = process.env.NODE_ENV === "production" ? "" : "/api";
Vue.config.productionTip = false;
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
const i18n = new VueI18n({
  locale: window.localStorage.getItem("lang")
    ? window.localStorage.getItem("lang")
    : "zh-cn",
  messages: {
    "zh-cn": require("./common/lang/cn"),
    "en-us": require("./common/lang/en")
  }
});
Vue.mixin({
  data() {
    return {
      locale: "zh-cn",
      keywords: null
    };
  },
  created() {
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
    this.getData(this.locale);
  },
  watch: {
    locale(a, b) {
      console.log("locale变化（indexproduct）", a, b);
      this.getData(this.locale);
    }
  },
  methods: {
    getData(lang) {
      if (isEmpty(this.keywords) && isEmpty(localStorage.getItem("keywords"))) {
        let lang2 = lang ? lang : "zh-cn";
        this.$axios
          .post(
            "/api/keyword/list",
            {},
            {
              headers: {
                token: "application",
                "Accept-Language": lang2
              }
            }
          )
          .then(res => {
            console.log(res);
            if (res.data.errorCode === 0) {
              this.keywords = res.data.data;
              localStorage.setItem("keywords", JSON.stringify(this.keywords));
            }
          });
      } else {
        this.keywords = JSON.parse(localStorage.getItem("keywords")).base;
      }
    }
  }
});
var hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?3df50238515268add9153f5e0ff055de";
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js